import React from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { Header, Segment } from 'semantic-ui-react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';

import BuildingSummaryForm from './BuildingSummaryForm';
import { Loading } from 'react-lib/dist/components-es';
import { locationsActions } from '../../behavior/locations';
import BSearchContainer from './BSearchContainer';
import BuildingSummaryOverviewTableContainer from './BuildingSummaryOverviewTableContainer';
import { entityType, recordOptionType } from '../../constants';
import { dataViewActions } from '../../behavior/dataview';

class BuildingSummaryFormContainer extends React.Component {
  componentDidMount() {
    if (!isNaN(this.props.buildingNum) || !isNaN(this.props.id)) {
      this.props.getSummary(this.props.buildingNum, this.props.id);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.buildingNum !== prevProps.buildingNum && !isNaN(this.props.buildingNum)) {
      this.props.resetBuildingSummary();
      this.props.defaultFilteredList.result.entityType = null;
      this.props.getSummary(this.props.buildingNum);
    }
  }

  componentWillReceiveProps(newProps) {
    const oldBuildingNum = this.getBuildingNum(this.props);
    const newBuildingNum = this.getBuildingNum(newProps);

    if (newBuildingNum && newBuildingNum != oldBuildingNum) {
      this.props.getDefaultDataView(entityType.building, newBuildingNum);
    }
  }

  getBuildingNum = props => {
    return (
      props.summary &&
      props.summary.buildingSummary &&
      props.summary.buildingSummary.location &&
      props.summary.buildingSummary.location.buildingNum
    );
  };

  componentWillUnmount() {
    this.props.resetBuildingSummary();
  }

  hideFormContainer = () => {
    const { summary, isLoading } = this.props;
    return !summary || Object.keys(summary).length <= 0 || isLoading ? true : false;
  };

  getBuildingSummary = () => {
    const { summary, t, title, buildingNum, id } = this.props;
    const { hazardList, hazardTypeList } = summary || {};
    const hideFormContainer = this.hideFormContainer();
    const detailContainerProps = {
      initialData: { hazardList, hazardTypeList },
      buildingId: id,
      buildingNum: this.getBuildingNum(this.props)
    };

    return (
      <>
        <Loading isLoading={hideFormContainer && (!isNaN(buildingNum) || !isNaN(id))} />
        {!hideFormContainer && (
          <Segment>
            {title && <Header as="h2">{t(title)}</Header>}

            <Formik
              initialValues={summary.buildingSummary}
              render={formikProps => (
                <BuildingSummaryForm
                  formikProps={formikProps}
                  detailContainerProps={detailContainerProps}
                />
              )}
            />
            {this.props.summary.hazardList.length > 0 &&
            this.props.summary.buildingSummary &&
            this.props.defaultFilteredList &&
            this.props.defaultFilteredList.result.entityType === entityType.building ? (
              <BuildingSummaryOverviewTableContainer
                hazardList={hazardList}
                entityType={entityType.building}
                tableOptions={[recordOptionType.view]}
                defaultFilteredList={this.props.defaultFilteredList}
                buildingNum={this.getBuildingNum(this.props)}
              />
            ) : null}
          </Segment>
        )}
      </>
    );
  };

  getSearchBuilding = () => (
    <BSearchContainer id={this.props.id} buildingNum={this.getBuildingNum(this.props)} />
  );

  render() {
    return (
      <div className="buildingDetails">
        {this.getSearchBuilding()}
        {this.getBuildingSummary()}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...state.locations,
  ...state.dataView,
  buildingNum: ownProps.match.params.buildingNum,
  id: ownProps.match.params.id
});

const mapDispatchToProps = dispatch => ({
  getSummary: (buildingNum, id) => dispatch(locationsActions.getBuildingSummary(buildingNum, id)),
  save: saveDto => dispatch(locationsActions.saveLocation(saveDto)),
  resetBuildingSummary: () => dispatch(locationsActions.resetBuildingSummary()),
  getDefaultDataView: (entityType, buildingNum) => {
    dispatch(dataViewActions.getDefaultDataView(entityType, null, null, null, { buildingNum }));
  }
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(BuildingSummaryFormContainer);
